var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"app-version grey--text caption px-1"},[_vm._v(" SmartPhone Ver. "+_vm._s(_vm.appVersion)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }